import { NextRouter } from 'next/router';

type ResetNewHomesFilter = ({
    asPath,
    push
}: {
    asPath: NextRouter['asPath'];
    push: NextRouter['push'];
}) => void;

export const resetNewHomesFilter: ResetNewHomesFilter = ({ asPath, push }) => {
    const regexNhLsrpPath = new RegExp(
        '/new-homes/(property|flats|houses|bungalows|retirement).+$'
    );

    const matches = asPath?.match(regexNhLsrpPath)?.length;

    if (matches && matches > 0) {
        const forSalePath = asPath.replace('/new-homes/', '/for-sale/');
        push(forSalePath);
    }
};
